module.exports = __webpack_public_path__ + "fce44bd4.svg";